// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { ReceiptItemFragmentDoc } from '../common-client-queries.generated';
export type RegisterPushSubscriptionMutationVariables = Types.Exact<{
  subscription: Types.Scalars['String'];
}>;

export type RegisterPushSubscriptionMutation = {
  readonly __typename: 'Mutation';
  readonly registerPushSubscription: boolean;
};

export type GetOcrAccountInfoQueryVariables = Types.Exact<{
  accountNumber: Types.Scalars['AccountNumber'];
}>;

export type GetOcrAccountInfoQuery = {
  readonly __typename: 'Query';
  readonly lookupOcrAccount: {
    readonly __typename: 'OcrAccount';
    readonly accountNumber: string;
    readonly beneficiaryName: string;
    readonly kidRequired: boolean;
    readonly taxReceiver: boolean;
    readonly kidSchemes: ReadonlyArray<{
      readonly __typename: 'KidScheme';
      readonly length: number;
      readonly algorithm: Types.KidAlgorithm;
    }>;
  } | null;
};

export type PollAgentDataQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PollAgentDataQuery = {
  readonly __typename: 'Query';
  readonly me: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly state: Types.AgentState;
    readonly type: Types.AgentType;
    readonly avatarId: Types.AvatarId;
  };
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly state: Types.OrgState;
  };
};

export type EventWithUploadFragment = {
  readonly __typename: 'Event';
  readonly fid: string;
  readonly completed: boolean;
  readonly receipts: ReadonlyArray<{
    readonly __typename: 'Receipt';
    readonly fid: string;
    readonly mime: string;
    readonly uploadedAt: string;
    readonly userData: string | null;
    readonly isInvoice: boolean;
    readonly receiptLooksValid: boolean;
    readonly images: {
      readonly __typename: 'ReceiptImages';
      readonly color: string;
      readonly originalUrl: string;
      readonly croppedUrl: string | null;
      readonly thumbnail128Url: string | null;
      readonly thumbnail256Url: string | null;
      readonly thumbnail512Url: string | null;
    };
  }>;
  readonly requirements: {
    readonly __typename: 'EventRequirements';
    readonly metRequirementCount: number;
    readonly totalRequirementCount: number;
    readonly allRequirementsMet: boolean;
    readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
    readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
  };
};

export type UploadFileResultFragment = {
  readonly __typename: 'UploadInfo';
  readonly receiptFid: string;
  readonly currentEvent: {
    readonly __typename: 'Event';
    readonly fid: string;
    readonly completed: boolean;
    readonly receipts: ReadonlyArray<{
      readonly __typename: 'Receipt';
      readonly fid: string;
      readonly mime: string;
      readonly uploadedAt: string;
      readonly userData: string | null;
      readonly isInvoice: boolean;
      readonly receiptLooksValid: boolean;
      readonly images: {
        readonly __typename: 'ReceiptImages';
        readonly color: string;
        readonly originalUrl: string;
        readonly croppedUrl: string | null;
        readonly thumbnail128Url: string | null;
        readonly thumbnail256Url: string | null;
        readonly thumbnail512Url: string | null;
      };
    }>;
    readonly requirements: {
      readonly __typename: 'EventRequirements';
      readonly metRequirementCount: number;
      readonly totalRequirementCount: number;
      readonly allRequirementsMet: boolean;
      readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
    };
  };
  readonly previousEvent: {
    readonly __typename: 'Event';
    readonly fid: string;
    readonly completed: boolean;
    readonly receipts: ReadonlyArray<{
      readonly __typename: 'Receipt';
      readonly fid: string;
      readonly mime: string;
      readonly uploadedAt: string;
      readonly userData: string | null;
      readonly isInvoice: boolean;
      readonly receiptLooksValid: boolean;
      readonly images: {
        readonly __typename: 'ReceiptImages';
        readonly color: string;
        readonly originalUrl: string;
        readonly croppedUrl: string | null;
        readonly thumbnail128Url: string | null;
        readonly thumbnail256Url: string | null;
        readonly thumbnail512Url: string | null;
      };
    }>;
    readonly requirements: {
      readonly __typename: 'EventRequirements';
      readonly metRequirementCount: number;
      readonly totalRequirementCount: number;
      readonly allRequirementsMet: boolean;
      readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
      readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
    };
  } | null;
};

export type UploadFilesMutationVariables = Types.Exact<{
  files: ReadonlyArray<Types.Scalars['Upload']> | Types.Scalars['Upload'];
  eventFid?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type UploadFilesMutation = {
  readonly __typename: 'Mutation';
  readonly uploadReceipts: ReadonlyArray<{
    readonly __typename: 'UploadInfo';
    readonly receiptFid: string;
    readonly currentEvent: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly completed: boolean;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      };
    };
    readonly previousEvent: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly completed: boolean;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      };
    } | null;
  }>;
};

export type UploadFileMutationVariables = Types.Exact<{
  file: Types.Scalars['Upload'];
  eventFid?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type UploadFileMutation = {
  readonly __typename: 'Mutation';
  readonly uploadReceipt: {
    readonly __typename: 'UploadInfo';
    readonly receiptFid: string;
    readonly currentEvent: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly completed: boolean;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      };
    };
    readonly previousEvent: {
      readonly __typename: 'Event';
      readonly fid: string;
      readonly completed: boolean;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
      };
    } | null;
  };
};

export const EventWithUploadFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'eventWithUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Event' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receipts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReceiptItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requirements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metRequirementCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRequirementCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allRequirementsMet' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allRequirements' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unmetRequirements' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventWithUploadFragment, unknown>;
export const UploadFileResultFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadFileResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'receiptFid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentEvent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'eventWithUpload' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousEvent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'eventWithUpload' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadFileResultFragment, unknown>;
export const RegisterPushSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterPushSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subscription' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerPushSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subscription' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'subscription' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterPushSubscriptionMutation,
  RegisterPushSubscriptionMutationVariables
>;
export const GetOcrAccountInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOcrAccountInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountNumber' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lookupOcrAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beneficiaryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'kidRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxReceiver' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kidSchemes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'length' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'algorithm' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOcrAccountInfoQuery,
  GetOcrAccountInfoQueryVariables
>;
export const PollAgentDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PollAgentData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PollAgentDataQuery, PollAgentDataQueryVariables>;
export const UploadFilesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'files' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'Upload' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventFid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadReceipts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'files' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'files' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eventFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'uploadFileResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UploadFileResultFragmentDoc.definitions,
    ...EventWithUploadFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<UploadFilesMutation, UploadFilesMutationVariables>;
export const UploadFileDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'file' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Upload' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventFid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadReceipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'file' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'file' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eventFid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'uploadFileResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UploadFileResultFragmentDoc.definitions,
    ...EventWithUploadFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<UploadFileMutation, UploadFileMutationVariables>;
